import script from "./SolutionView.vue?vue&type=script&setup=true&lang=ts"
export * from "./SolutionView.vue?vue&type=script&setup=true&lang=ts"

import "./SolutionView.vue?vue&type=style&index=0&id=9e0bfc58&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9e0bfc58"]])

export default __exports__